import { createBaseOptions, fetchJson, METHOD_GET } from "../../utils/SuperAgentFetch";
import { config } from "../../config/Config";

export const fetchUseEntryTypeInFolder = (type, callback) => {


    /** @type RequestOptions */
    let options = createBaseOptions();
    options.method = METHOD_GET;
    options.headers["Content-Type"] = "application/json";

    let r = fetchJson(`${config.url.API_URL}/entryTypes/custom/itemByType/${type}/deleteFolders`, options);
    r.then(json => {
        let res = [];
        if (json._embedded && json._embedded.bmcEntries && json._embedded.bmcEntries.length > 0) {
            res = json._embedded.bmcEntries;
            callback(res);
        }

    }).catch(error => {
        console.log(error);
        // callback(error);
    });
};

